import { render, staticRenderFns } from "./AddMember.vue?vue&type=template&id=373e793c&scoped=true"
import script from "./AddMember.vue?vue&type=script&lang=js"
export * from "./AddMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373e793c",
  null
  
)

export default component.exports